export default __webpack_public_path__ + "static/media/fa.35898ede.jpg";